  import React, { useState, useEffect } from "react";
  import { Modal } from "react-bootstrap";
  import AppShell from "../layouts/AppShell";
  import { appBank, appModules } from "../components/global";
  import Switch from "react-switch";
  import { GET, POST, PUT, DELETE, loading, alert, format_date, required, Select, DateInput } from "../components/CustomComponent";
  import { DocumentManagerPanel } from "../components/DocumentManager";
  import PositionBadge from "../components/PositionBadge";
  import OrgChartMatrix from "../components/OrgChartMatrix";
  import provinceData from "../assets/files/th_province.json";

  const modalInputStyle = {
    borderRadius: 12,
    border: "1px solid #c9d7e3",
    background: "#ffffff",
    color: "#1b3950",
    boxShadow: "none",
  };

  // กรอบนอกของ input-group: ถือ border + มุมโค้ง แล้ว clip ลูกข้างในให้เข้ารูป
  const groupWrapStyle = {
    ...modalInputStyle,
    padding: 0,
    overflow: "hidden",
  };
  // ช่องกรอกข้างใน — ไม่มี border/มุมของตัวเอง
  const groupFieldStyle = {
    border: 0,
    borderRadius: 0,
    background: "transparent",
    color: "#1b3950",
    boxShadow: "none",
  };
  // ป้ายต่อท้าย (addon) เช่น "%" — พื้นหลังอ่อน มีเส้นคั่นซ้ายเส้นเดียว
  const groupAddonStyle = {
    border: 0,
    borderLeft: "1px solid #c9d7e3",
    borderRadius: 0,
    background: "#eef4fb",
    color: "#4f6d83",
    fontWeight: 600,
  };

  const modalLabelStyle = {
    color: "#0b4f84",
    fontSize: "0.82rem",
    fontWeight: 800,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    marginBottom: 8,
  };

  const sectionCardStyle = {
    background: "linear-gradient(180deg, #ffffff 0%, #ebf6ff 100%)",
    border: "1px solid rgba(15, 102, 182, 0.16)",
    borderRadius: 24,
    boxShadow: "0 18px 36px rgba(11, 90, 167, 0.10)",
  };

  const SIGNATURE_MAX_BYTES = 5 * 1024 * 1024;

  const readFileAsBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  const employeeFormDefaults = {
    employee_code: "",
    role_id: "",
    prefix_name: "",
    first_name: "",
    last_name: "",
    nickname: "",
    national_id: "",
    gender: "",
    birthday: "",
    phone: "",
    email: "",
    password: "",
    address: "",
    province: "",
    district: "",
    sub_district: "",
    zip_code: "",
    picture: "",
    // ลายเซ็นพนักงาน signature_file = ไฟล์ที่เพิ่งเลือกใหม่, ส่วน signature_url/name ใช้แสดงไฟล์เดิม
    signature_file: null,
    signature_remove: false,
    signature_url: "",
    signature_name: "",
    signature_mime: "",
    signature_type: "",
    department: "",
    position: "",
    salary: "",
    wht_rate: "",
    start_date: "",
    employment_type: "full_time",
    probation_end_date: "",
    contract_start_date: "",
    contract_end_date: "",
    end_date: "",
    resignation_reason: "",
    working_start_time: "",
    working_end_time: "",
    bank_name: "",
    bank_account_no: "",
    bank_account_name: "",
    status: "",
    // ข้อมูลประกันสังคม
    is_social_security: true,
    sso_number: "",
    sso_section: "33",
    sso_rate: "5",
    sso_wage_ceiling: "17500",
    sso_hospital: "",
    is_active: true,
  };

  const employmentTypeOptions = [
    { value: "full_time", label: "พนักงานประจำ" },
    { value: "probation", label: "ทดลองงาน" },
    { value: "contract", label: "สัญญาจ้าง" },
    { value: "part_time", label: "พาร์ทไทม์" },
    { value: "intern", label: "ฝึกงาน" },
    { value: "outsource", label: "จ้างภายนอก" },
  ];

  const historyTypeLabels = {
    position: "ปรับตำแหน่ง",
    salary: "ปรับเงินเดือน",
    department: "ย้ายแผนก",
    employment_type: "เปลี่ยนรูปแบบจ้าง",
    status: "เปลี่ยนสถานะ",
    contract: "สัญญาจ้าง",
    resignation: "พ้นสภาพ",
    training: "อบรม",
    award: "รางวัล",
    warning: "ตักเตือน",
    other: "อื่นๆ",
  };

  const historyTypeLabel = (type) => historyTypeLabels[type] || type;

  const departmentOptions = [
    { value: "MANAGEMENT", label: "Management" },
    { value: "ADMIN", label: "Admin" },
    { value: "ACC", label: "Accounting" },
    { value: "HR", label: "HR" },
    { value: "IT", label: "IT" },
    { value: "DEV", label: "Software Development" },
    { value: "CS", label: "Customer Support" },
    { value: "SALE", label: "Sales" },
    { value: "OP", label: "Operations" },
  ];

  const positionOptions = [
    { value: "CEO", label: "CEO" },
    { value: "CTO", label: "CTO" },
    { value: "CFO", label: "CFO" },
    { value: "MANAGER", label: "Manager" },
    { value: "ADMIN", label: "Admin" },
    { value: "HR_OFFICER", label: "HR Officer" },
    { value: "ACCOUNTANT", label: "Accountant" },
    { value: "SOFTWARE_ENGINEER", label: "Software Engineer" },
    { value: "CUSTOMER_SUPPORT", label: "Customer Support" },
  ];

  const statusOptions = [
    { value: "ทดลองงาน", label: "ทดลองงาน" },
    { value: "ทำงานปกติ", label: "ทำงานปกติ" },
    { value: "ฟรีแลนซ์", label: "ฟรีแลนซ์" },
    { value: "ลาออก", label: "ลาออก" },
    { value: "พักงาน", label: "พักงาน" },
  ];

  const bankImageContext = require.context("../assets/images/bank", false, /\.(png|jpe?g|svg)$/);

  // webpack 5 คืนไฟล์รูปเป็น ES module ({ default: url }) ต้องดึง .default ออกมา
  // ไม่งั้น src จะกลายเป็น "[object Module]" แล้วรูปไม่ขึ้น
  const getBankImage = (icon) => {
    try {
      const asset = bankImageContext(`./${icon}`);
      return asset?.default || asset || null;
    } catch (error) {
      return null;
    }
  };

  const bankOptions = appBank.map((bank) => {
    const image = getBankImage(bank.icon);
    return {
      value: bank.value,
      label: bank.name_th || bank.label,
      front: image ? (
        <img
          src={image}
          alt={bank.label}
          style={{
            width: 22,
            height: 22,
            objectFit: "contain",
            marginRight: 8,
            borderRadius: 999,
            background: "#ffffff",
          }}
        />
      ) : null,
    };
  });

  const getFullName = (employee) =>
    [employee?.prefix_name, employee?.first_name, employee?.last_name].filter(Boolean).join(" ") || "-";

  const parseBirthday = (birthday) => {
    if (!birthday) return null;
    const date = new Date(birthday);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  // วันเกิดรอบถัดไป (ถ้าปีนี้เลยไปแล้ว = ปีหน้า)
  const getNextBirthday = (birthday) => {
    const birthDate = parseBirthday(birthday);
    if (!birthDate) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let nextBirthday = new Date(today.getFullYear(), birthDate.getMonth(), birthDate.getDate());
    if (nextBirthday < today) {
      nextBirthday = new Date(today.getFullYear() + 1, birthDate.getMonth(), birthDate.getDate());
    }

    return nextBirthday;
  };

  const getDaysUntilBirthday = (birthday) => {
    const nextBirthday = getNextBirthday(birthday);
    if (!nextBirthday) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return Math.round((nextBirthday - today) / (1000 * 60 * 60 * 24));
  };

  // ยึดวันเกิดรอบถัดไป ไม่ใช่แค่เดือนตรงกัน
  // ไม่งั้นวันเกิดที่เลยไปแล้วในเดือนนี้ จะยังโชว์หมวก/แถบฉลองทั้งที่ต้องรออีกเกือบปี
  const isBirthdayThisMonth = (birthday) => {
    const nextBirthday = getNextBirthday(birthday);
    if (!nextBirthday) return false;

    const today = new Date();
    return nextBirthday.getFullYear() === today.getFullYear() && nextBirthday.getMonth() === today.getMonth();
  };

  // เวลาทำงานเก็บเป็น TIME (HH:mm:ss) ตัดวินาทีออกให้เหลือ 09:00-17:00 น.
  const formatWorkingHours = (employee) => {
    const trim = (value) => (value ? String(value).slice(0, 5) : "");
    const start = trim(employee.working_start_time);
    const end = trim(employee.working_end_time);
    if (!start && !end) return "-";
    if (!start || !end) return `${start || end} น.`;
    return `${start}-${end} น.`;
  };

  // ดาวประกายสีชมพู (ใช้ซ้ำหลายดวง)
  const sparkleStar = "M0,-6 L1.53,-2.1 L5.7,-1.85 L2.47,0.8 L3.5,4.85 L0,2.6 L-3.5,4.85 L-2.47,0.8 L-5.7,-1.85 L-1.53,-2.1 Z";

  // ตำแหน่งหมวกอยู่ใน style.css (.party-hat-anchor)
  // จอใหญ่ = ลอยเหนือตัวอักษร / จอมือถือที่ตารางกลายเป็นการ์ด = วางต่อท้ายชื่อแทน
  // ไม่งั้นหมวกจะลอยไปทับแถวด้านบนซึ่งเป็นพื้นที่ว่างสีขาวของการ์ด
  const PartyHat = () => (
    <span className="party-hat-anchor" title="วันเกิดเดือนนี้ 🎉">
      <span
        className="party-hat"
        style={{
          display: "inline-block",
          transformOrigin: "bottom center",
          filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.15))",
        }}
      >
        <svg width="34" height="36" viewBox="0 0 60 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="coneClip">
              <path d="M30 8 L50 58 L10 58 Z" />
            </clipPath>
          </defs>

          {/* กรวยหมวกเอียง */}
          <g transform="rotate(13 30 58)">
            {/* เนื้อหมวกสีส้ม */}
            <path d="M30 8 L50 58 L10 58 Z" fill="#ef9d43" />
            {/* ลายทางเหลืองแนวนอน */}
            <g clipPath="url(#coneClip)">
              <rect x="6" y="16" width="48" height="5" fill="#f5d04a" />
              <rect x="6" y="27" width="48" height="5.5" fill="#f5d04a" />
              <rect x="6" y="39" width="48" height="6" fill="#f5d04a" />
              <rect x="6" y="51" width="48" height="6.5" fill="#f5d04a" />
            </g>
            {/* ปอมปอมม่วงหยัก ๆ ที่ยอดหมวก */}
            <g fill="#ad9ce6">
              <circle cx="30" cy="8" r="4.2" />
              <circle cx="34" cy="8" r="3.1" />
              <circle cx="32" cy="11.4" r="3.1" />
              <circle cx="28" cy="11.4" r="3.1" />
              <circle cx="26" cy="8" r="3.1" />
              <circle cx="28" cy="4.6" r="3.1" />
              <circle cx="32" cy="4.6" r="3.1" />
            </g>
          </g>

          {/* ดาวประกายชมพู */}
          <path d={sparkleStar} transform="translate(13 17) scale(1.05)" fill="#e07ec9" />
          <path d={sparkleStar} transform="translate(8 36) scale(0.8)" fill="#e98fd2" />
          <path d={sparkleStar} transform="translate(52 40) scale(0.95)" fill="#e07ec9" />
        </svg>
      </span>
    </span>
  );

  // อายุเต็มปี ณ วันนี้ (ยังไม่ถึงวันเกิดปีนี้ = ลบหนึ่งปี)
  const getAge = (birthday) => {
    const birthDate = parseBirthday(birthday);
    if (!birthDate) return null;

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) age -= 1;
    return age >= 0 ? age : null;
  };

  // ข้อความตอนเอาเมาส์ไปชี้ที่ป้ายนับถอยหลัง: วันเกิดจริง + อายุ
  const birthdayTooltip = (birthday) => {
    const date = format_date(birthday, "dd mmm yyyy");
    if (date === "-") return "";
    const age = getAge(birthday);
    return `เกิดวันที่ ${date}${age === null ? "" : ` · อายุ ${age} ปี`}`;
  };

  const renderBirthdayCountdown = (birthday) => {
    const days = getDaysUntilBirthday(birthday);
    if (days === null) {
      return <span className="text-secondary small">—</span>;
    }

    const thisMonth = isBirthdayThisMonth(birthday);
    const soon = days > 0 && days <= 7;
    const tooltip = birthdayTooltip(birthday);

    const baseStyle = {
      borderRadius: 999,
      padding: "6px 14px",
      fontWeight: 700,
      fontSize: "0.82rem",
      lineHeight: 1,
      gap: 6,
      whiteSpace: "nowrap",
      cursor: "help",
    };

    // เกิดวันนี้ — เด่นที่สุด มีอนิเมชันเรืองแสง
    if (days === 0) {
      return (
        <span
          className="d-inline-flex align-items-center birthday-pulse"
          title={tooltip}
          style={{
            ...baseStyle,
            color: "#ffffff",
            background: "linear-gradient(135deg, #ff5e8a 0%, #ff8a5b 55%, #ffc14d 100%)",
            boxShadow: "0 8px 18px rgba(255, 94, 138, 0.45)",
          }}
        >
          <span style={{ fontSize: "1rem" }}>🎂</span> สุขสันต์วันเกิด!
        </span>
      );
    }

    // เกิดเดือนนี้ — gradient อุ่น ๆ เด่น
    if (thisMonth) {
      return (
        <span
          className="d-inline-flex align-items-center"
          title={tooltip}
          style={{
            ...baseStyle,
            color: "#ffffff",
            background: "linear-gradient(135deg, #ff8a65 0%, #ffb74d 100%)",
            boxShadow: "0 6px 14px rgba(255, 138, 101, 0.36)",
          }}
        >
          <span style={{ fontSize: "0.95rem" }}>🎉</span> อีก {days} วัน
        </span>
      );
    }

    // ใกล้ถึงใน 7 วัน — เน้นอ่อน ๆ
    if (soon) {
      return (
        <span
          className="d-inline-flex align-items-center"
          title={tooltip}
          style={{
            ...baseStyle,
            color: "#b97007",
            background: "rgba(245, 166, 35, 0.16)",
            border: "1px solid rgba(245, 166, 35, 0.32)",
          }}
        >
          <span style={{ fontSize: "0.9rem" }}>🎈</span> อีก {days} วัน
        </span>
      );
    }

    // ปกติ — เรียบ
    return (
      <span
        className="d-inline-flex align-items-center"
        title={tooltip}
        style={{
          ...baseStyle,
          fontWeight: 600,
          color: "#566575",
          background: "rgba(108, 122, 137, 0.10)",
        }}
      >
        อีก {days} วัน
      </span>
    );
  };

  const formatSalaryDisplay = (value) => {
    if (value === undefined || value === null || value === "") {
      return "";
    }

    const numericValue = Number(String(value).replace(/,/g, ""));
    if (Number.isNaN(numericValue)) {
      return "";
    }

    return Math.floor(numericValue).toLocaleString("en-US");
  };

  const getStatusBadgeStyle = (status) => {
    if (status === "ทำงานปกติ") {
      return {
        background: "rgba(47, 181, 114, 0.14)",
        color: "#188251",
      };
    }

    if (status === "ทดลองงาน") {
      return {
        background: "rgba(245, 166, 35, 0.16)",
        color: "#b97007",
      };
    }

    if (status === "ฟรีแลนซ์") {
      return {
        background: "rgba(12, 118, 229, 0.14)",
        color: "#0b4f84",
      };
    }

    if (status === "ลาออก") {
      return {
        background: "rgba(229, 83, 83, 0.16)",
        color: "#b63636",
      };
    }

    return {
      background: "rgba(108, 122, 137, 0.14)",
      color: "#566575",
    };
  };

  const provinceOptions = provinceData.map((item) => item.th);

  const normalizeEmployeeForm = (editData) => ({
    ...employeeFormDefaults,
    uid: editData?.uid || "",
    employee_code: editData?.employee_code || editData?.empId || "",
    role_id: editData?.role_id || editData?.role?.uid || "",
    prefix_name: editData?.prefix_name || "",
    first_name: editData?.first_name || "",
    last_name: editData?.last_name || "",
    nickname: editData?.nickname || "",
    national_id: editData?.national_id || "",
    gender: editData?.gender || "",
    birthday: editData?.birthday || "",
    phone: editData?.phone || "",
    email: editData?.email || "",
    password: "",
    address: editData?.address || "",
    province: editData?.province || "",
    district: editData?.district || "",
    sub_district: editData?.sub_district || "",
    zip_code: editData?.zip_code || "",
    picture: editData?.picture || "",
    signature_file: null,
    signature_remove: false,
    signature_url: editData?.signature_url || "",
    signature_name: editData?.signature_name || "",
    signature_mime: editData?.signature_mime || "",
    signature_type: editData?.signature_type || "",
    department: editData?.department || "",
    position: editData?.position || "",
    salary: editData?.salary || "",
    wht_rate: editData?.wht_rate ?? "",
    start_date: editData?.start_date || "",
    employment_type: editData?.employment_type || "full_time",
    probation_end_date: editData?.probation_end_date || "",
    contract_start_date: editData?.contract_start_date || "",
    contract_end_date: editData?.contract_end_date || "",
    end_date: editData?.end_date || "",
    resignation_reason: editData?.resignation_reason || "",
    working_start_time: editData?.working_start_time || "",
    working_end_time: editData?.working_end_time || "",
    bank_name: editData?.bank_name || "",
    bank_account_no: editData?.bank_account_no || "",
    bank_account_name: editData?.bank_account_name || "",
    status: editData?.status || "",
    is_social_security: editData?.is_social_security ?? true,
    sso_number: editData?.sso_number || "",
    sso_section: editData?.sso_section || "33",
    sso_rate: editData?.sso_rate ?? "5",
    sso_wage_ceiling: editData?.sso_wage_ceiling ?? "17500",
    sso_hospital: editData?.sso_hospital || "",
    is_active: editData?.is_active ?? true,
  });

  // แท็บระดับหน้า: รายชื่อพนักงาน / ผังองค์กร
  const pageViews = [
    { key: "list", label: "รายชื่อพนักงาน", icon: "fa-solid fa-table-list" },
    { key: "org", label: "ผังองค์กร", icon: "fa-solid fa-sitemap" },
  ];

  const employeeTabs = [
    { key: "personal", label: "ข้อมูลประจำตัว", icon: "fa-solid fa-id-card" },
    { key: "work", label: "ข้อมูลตำแหน่งงาน", icon: "fa-solid fa-briefcase" },
    { key: "sso", label: "ข้อมูลประกันสังคม", icon: "fa-solid fa-shield-heart" },
    { key: "bank", label: "ข้อมูลบัญชี", icon: "fa-solid fa-building-columns" },
    { key: "employment", label: "สัญญาจ้าง / ประวัติ", icon: "fa-solid fa-file-signature" },
    { key: "documents", label: "เอกสาร", icon: "fa-solid fa-folder-open" },
  ];

  const EmployeeModal = ({ show, onHide, editData, onSave, roleOptions = [], histories = [], onAddHistory, onDeleteHistory }) => {
    const [formData, setFormData] = useState(employeeFormDefaults);
    const [activeTab, setActiveTab] = useState("personal");
    const numericOnlyFields = ["phone", "bank_account_no", "salary", "national_id"];

    useEffect(() => {
      setFormData(normalizeEmployeeForm(editData));
      setActiveTab("personal");
    }, [editData, show]);

    const handleChange = (event) => {
      const { name, value } = event.target;
      const normalizedValue = numericOnlyFields.includes(name)
        ? value.replace(/\D/g, "")
        : value;

      setFormData((current) => {
        if (name === "province") {
          return {
            ...current,
            province: normalizedValue,
            district: "",
            sub_district: "",
            zip_code: "",
          };
        }

        if (name === "district") {
          return {
            ...current,
            district: normalizedValue,
            sub_district: "",
            zip_code: "",
          };
        }

        if (name === "sub_district") {
          const selectedProvince = provinceData.find((item) => item.th === current.province);
          const selectedDistrict = selectedProvince?.district?.find((item) => item.th === current.district);
          const selectedSubDistrict = selectedDistrict?.sub_district?.find((item) => item.th === normalizedValue);

          return {
            ...current,
            sub_district: normalizedValue,
            zip_code: selectedSubDistrict ? String(selectedSubDistrict.code) : "",
          };
        }

        if (name === "zip_code") {
          return {
            ...current,
            zip_code: normalizedValue,
          };
        }

        return {
          ...current,
          [name]: normalizedValue,
        };
      });
    };

    const handleToggleActive = (checked) => {
      setFormData((current) => ({
        ...current,
        is_active: checked,
      }));
    };

    // เลือกไฟล์ลายเซ็น รองรับภาพหรือ PDF และเก็บเป็น base64 เพื่อส่งไปพร้อมกับตอนบันทึก
    const handleSignatureChange = async (event) => {
      const file = event.target.files?.[0];
      event.target.value = "";
      if (!file) return;

      const isImage = file.type?.startsWith("image/");
      const isPdf = file.type === "application/pdf";

      if (!isImage && !isPdf) {
        await alert("", "warning", "แจ้งเตือน", "รองรับเฉพาะไฟล์ภาพ หรือ PDF เท่านั้น");
        return;
      }

      if (file.size > SIGNATURE_MAX_BYTES) {
        await alert("", "warning", "แจ้งเตือน", "ไฟล์ลายเซ็นต้องมีขนาดไม่เกิน 5 MB");
        return;
      }

      const base64 = await readFileAsBase64(file);

      setFormData((current) => ({
        ...current,
        signature_file: { file_name: file.name, mime_type: file.type, file_base64: base64 },
        signature_remove: false,
        signature_url: isImage ? base64 : "",
        signature_name: file.name,
        signature_mime: file.type,
        signature_type: isImage ? "image" : "pdf",
      }));
    };

    const handleSignatureRemove = async () => {
      if (!(await alert("", "warning", "ลบรายการ", "ต้องการลบไฟล์ลายเซ็นนี้ใช่หรือไม่?", "ยืนยัน", "ยกเลิก"))) return;

      setFormData((current) => ({
        ...current,
        signature_file: null,
        // ถ้าเคยมีไฟล์เดิมอยู่บนเซิร์ฟเวอร์ ต้องบอก backend ให้ลบตอนกดบันทึก
        signature_remove: Boolean(editData?.signature_name),
        signature_url: "",
        signature_name: "",
        signature_mime: "",
        signature_type: "",
      }));
    };

    const displayEmployeeName = [formData.first_name, formData.last_name].filter(Boolean).join(" ") || editData?.name || "สร้างโปรไฟล์พนักงานใหม่";
    const selectedProvince = provinceData.find((item) => item.th === formData.province);
    const districtOptions = selectedProvince?.district?.map((item) => item.th) || [];
    const selectedDistrict = selectedProvince?.district?.find((item) => item.th === formData.district);
    const subDistrictOptions = selectedDistrict?.sub_district?.map((item) => item.th) || [];
    const selectedSubDistrict = selectedDistrict?.sub_district?.find((item) => item.th === formData.sub_district);
    const zipCodeOptions = selectedSubDistrict ? [String(selectedSubDistrict.code)] : [];
    const provinceSelectOptions = provinceOptions.map((province) => ({ value: province, label: province }));
    const districtSelectOptions = districtOptions.map((district) => ({ value: district, label: district }));
    const subDistrictSelectOptions = subDistrictOptions.map((subDistrict) => ({ value: subDistrict, label: subDistrict }));
    const zipCodeSelectOptions = zipCodeOptions.map((zipCode) => ({ value: zipCode, label: zipCode }));

    return (
        <Modal show={show} onHide={onHide} centered size="xl" contentClassName="border-0 shadow-lg overflow-hidden" dialogClassName="modal-dialog-scrollable">
            <Modal.Header
                closeButton
                className="border-0 p-4"
                style={{
                    background: "radial-gradient(circle at top right, rgba(38, 218, 222, 0.28), transparent 24%), linear-gradient(135deg, #d9eeff 0%, #bfe1ff 44%, #e7f6ff 100%)",
                }}
            >
                <div className="w-100">
                    <Modal.Title className="fw-bold" style={{ color: "#11324c", fontSize: "1.75rem" }}>
                        {editData ? "แก้ไขข้อมูลพนักงาน" : "เพิ่มพนักงานใหม่"}
                    </Modal.Title>
                </div>
            </Modal.Header>

            <Modal.Body className="px-5 py-3" style={{ background: "linear-gradient(180deg, #fcfeff 0%, #f5faff 100%)" }}>
                <div
                    className="rounded-4 p-3 mb-4"
                    style={{
                        background: "linear-gradient(135deg, rgba(12, 118, 229, 0.18) 0%, rgba(47, 213, 228, 0.20) 100%)",
                        border: "1px solid rgba(18, 125, 255, 0.20)",
                        boxShadow: "0 14px 28px rgba(18, 125, 255, 0.08)",
                    }}
                >
                    <div className="row g-3 align-items-center">
                        <div className="col-md-8">
                            <div className="small text-uppercase fw-bold mb-2" style={{ color: "#0f6db3", letterSpacing: "0.12em" }}>
                                Employee Status
                            </div>
                            <div className="fw-bold" style={{ color: "#0b3150", fontSize: "1.1rem" }}>
                                {displayEmployeeName}
                            </div>
                            <div className="small mt-1" style={{ color: "#285a7f" }}>
                                {editData ? "อัปเดตข้อมูลสำคัญของพนักงานให้เป็นปัจจุบัน" : "กรอกข้อมูลพื้นฐานเพื่อเริ่มต้นใช้งานในระบบ"}
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div
                                className="rounded-4 p-3 d-flex align-items-center justify-content-between"
                                style={{
                                    background: "rgba(255,255,255,0.92)",
                                    boxShadow: "inset 0 0 0 1px rgba(18, 125, 255, 0.16)",
                                }}
                            >
                                <div>
                                    <div className="small fw-bold text-uppercase mb-1" style={{ color: "#0d6ab0", letterSpacing: "0.08em" }}>
                                        Active
                                    </div>
                                    <div className="fw-semibold" style={{ color: "#12314d" }}>
                                        {formData.is_active ? "พร้อมใช้งาน" : "ปิดใช้งาน"}
                                    </div>
                                </div>
                                <Switch checked={formData.is_active} onChange={handleToggleActive} onColor="#0c75e6" offColor="#b7cadb" height={26} width={52} id="isActiveEmployee" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* แท็บแบ่งข้อมูลเป็นส่วน ๆ */}
                <ul className="nav nav-pills flex-nowrap gap-2 mb-4 overflow-auto pb-1" style={{ flexWrap: "nowrap" }}>
                    {employeeTabs.filter((tab) => !["documents", "employment"].includes(tab.key) || editData?.uid).map((tab) => {
                        const isActive = activeTab === tab.key;
                        return (
                            <li className="nav-item" key={tab.key}>
                                <button
                                    type="button"
                                    onClick={() => setActiveTab(tab.key)}
                                    className="nav-link d-flex align-items-center gap-2 px-3 px-md-4 text-nowrap"
                                    style={{
                                        borderRadius: 14,
                                        fontWeight: 600,
                                        color: isActive ? "#ffffff" : "#2d6288",
                                        background: isActive
                                            ? "linear-gradient(135deg, #0c75e6 0%, #2fd5e4 100%)"
                                            : "rgba(255,255,255,0.92)",
                                        border: isActive ? "none" : "1px solid rgba(18, 125, 255, 0.16)",
                                        boxShadow: isActive ? "0 12px 22px rgba(12, 117, 230, 0.22)" : "none",
                                    }}
                                >
                                    <i className={tab.icon} />
                                    {tab.label}
                                </button>
                            </li>
                        );
                    })}
                </ul>

                <form className="row g-4">
                    {activeTab === "personal" && (
                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-2 mb-4">
                                <div>
                                    <div className="small text-uppercase fw-bold mb-2" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                        Personal Information
                                    </div>
                                    <div style={{ color: "#2d6288", lineHeight: 1.7 }}>
                                        ข้อมูลประจำตัวและช่องทางติดต่อหลักของพนักงาน
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>รหัสพนักงาน</label>
                                    <input
                                        type="text"
                                        name="employee_code"
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.employee_code}
                                        onChange={handleChange}
                                        placeholder="ระบบจะสร้างอัตโนมัติ"
                                        disabled
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>คำนำหน้า {required}</label>
                                    <select
                                        name="prefix_name"
                                        className="form-select"
                                        style={modalInputStyle}
                                        value={formData.prefix_name}
                                        onChange={handleChange}
                                    >
                                        <option value="">เลือกคำนำหน้า</option>
                                        <option value="นาย">นาย</option>
                                        <option value="นาง">นาง</option>
                                        <option value="นางสาว">นางสาว</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ชื่อ {required}</label>
                                    <input type="text" name="first_name" className="form-control" style={modalInputStyle} value={formData.first_name} onChange={handleChange} placeholder="ระบุชื่อ" />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>นามสกุล {required}</label>
                                    <input type="text" name="last_name" className="form-control" style={modalInputStyle} value={formData.last_name} onChange={handleChange} placeholder="ระบุนามสกุล" />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ชื่อเล่น</label>
                                    <input type="text" name="nickname" className="form-control" style={modalInputStyle} value={formData.nickname} onChange={handleChange} placeholder="ระบุชื่อเล่น" />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>เลขประจำตัวประชาชน</label>
                                    <input type="text" name="national_id" maxLength={13} className="form-control" style={modalInputStyle} value={formData.national_id} onChange={handleChange} placeholder="เลขบัตรประชาชน 13 หลัก" inputMode="numeric" />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>เพศ</label>
                                    <select name="gender" className="form-select" style={modalInputStyle} value={formData.gender} onChange={handleChange}>
                                        <option value="">เลือกเพศ</option>
                                        <option value="male">ชาย</option>
                                        <option value="female">หญิง</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>วันเกิด</label>
                                    <DateInput name="birthday" className="form-control" style={modalInputStyle} value={formData.birthday} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>เบอร์โทรศัพท์</label>
                                    <input type="text" name="phone" maxLength={10} className="form-control" style={modalInputStyle} value={formData.phone} onChange={handleChange} placeholder="08x-xxx-xxxx" />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>อีเมล {required}</label>
                                    <input type="email" name="email" className="form-control" style={modalInputStyle} value={formData.email} onChange={handleChange} placeholder="email@company.com" />
                                </div>
                                {!editData && (
                                    <div className="col-md-6">
                                        <label className="form-label" style={modalLabelStyle}>Password {required}</label>
                                        <input type="password" name="password" className="form-control" style={modalInputStyle} value={formData.password} onChange={handleChange} placeholder="กรอกรหัสผ่านสำหรับพนักงาน" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    )}

                    {activeTab === "personal" && (
                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-2 mb-4">
                                <div>
                                    <div className="small text-uppercase fw-bold mb-2" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                        Signature
                                    </div>
                                    <div style={{ color: "#2d6288", lineHeight: 1.7 }}>
                                        ลายเซ็นพนักงานสำหรับใช้ประกอบเอกสาร รองรับไฟล์ภาพ หรือ PDF ขนาดไม่เกิน 5 MB
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ไฟล์ลายเซ็น (ภาพ หรือ PDF)</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        style={modalInputStyle}
                                        accept="image/*,.pdf,application/pdf"
                                        onChange={handleSignatureChange}
                                    />
                                    <div className="small mt-2" style={{ color: "#6b8198" }}>
                                        ไฟล์จะถูกบันทึกเมื่อกดปุ่มบันทึกข้อมูลพนักงาน
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ลายเซ็นปัจจุบัน</label>
                                    <div
                                        className="rounded-4 p-3 d-flex flex-column gap-3"
                                        style={{ background: "rgba(255,255,255,0.92)", boxShadow: "inset 0 0 0 1px rgba(18, 125, 255, 0.16)", minHeight: 132 }}
                                    >
                                        {!formData.signature_name && (
                                            <div className="d-flex align-items-center justify-content-center flex-grow-1" style={{ color: "#8aa2b6" }}>
                                                ยังไม่มีไฟล์ลายเซ็น
                                            </div>
                                        )}
                                        {formData.signature_name && formData.signature_type === "image" && formData.signature_url && (
                                            <img
                                                src={formData.signature_url}
                                                alt="ลายเซ็นพนักงาน"
                                                style={{ maxHeight: 96, maxWidth: "100%", objectFit: "contain", alignSelf: "flex-start" }}
                                            />
                                        )}
                                        {formData.signature_name && (
                                            <div className="d-flex align-items-center justify-content-between gap-2 flex-wrap">
                                                <span className="text-break" style={{ color: "#12314d" }}>
                                                    <i className={`fa-solid ${formData.signature_type === "pdf" ? "fa-file-pdf text-danger" : "fa-file-image text-primary"} me-2`} />
                                                    {formData.signature_name}
                                                </span>
                                                <div className="d-flex gap-2">
                                                    {!formData.signature_file && formData.signature_url && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary rounded-3 px-3"
                                                            title="เปิดดูไฟล์"
                                                            onClick={() => window.open(formData.signature_url, "_blank")}
                                                        >
                                                            <i className="fa-solid fa-eye" />
                                                        </button>
                                                    )}
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger rounded-3 px-3"
                                                        title="ลบไฟล์ลายเซ็น"
                                                        onClick={handleSignatureRemove}
                                                    >
                                                        <i className="fa-solid fa-trash" />
                                                    </button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {activeTab === "personal" && (
                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-2 mb-4">
                                <div>
                                    <div className="small text-uppercase fw-bold mb-2" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                        Address Information
                                    </div>
                                    <div style={{ color: "#2d6288", lineHeight: 1.7 }}>
                                        รายละเอียดที่อยู่ตามทะเบียนหรือที่อยู่ปัจจุบันของพนักงาน
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-12">
                                    <label className="form-label" style={modalLabelStyle}>ที่อยู่</label>
                                    <textarea
                                        name="address"
                                        className="form-control"
                                        style={{ ...modalInputStyle, minHeight: 108, resize: "none" }}
                                        value={formData.address}
                                        onChange={handleChange}
                                        placeholder="บ้านเลขที่ ถนน ซอย หมู่บ้าน"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>จังหวัด</label>
                                    <Select
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.province}
                                        options={provinceSelectOptions}
                                        placeholder="เลือกจังหวัด"
                                        onChange={(value) =>
                                          handleChange({ target: { name: "province", value } })
                                        }
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>อำเภอ / เขต</label>
                                    <Select
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.district}
                                        options={districtSelectOptions}
                                        placeholder="เลือกอำเภอ / เขต"
                                        disabled={!formData.province}
                                        onChange={(value) =>
                                          handleChange({ target: { name: "district", value } })
                                        }
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ตำบล / แขวง</label>
                                    <Select
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.sub_district}
                                        options={subDistrictSelectOptions}
                                        placeholder="เลือกตำบล / แขวง"
                                        disabled={!formData.district}
                                        onChange={(value) =>
                                          handleChange({ target: { name: "sub_district", value } })
                                        }
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>รหัสไปรษณีย์</label>
                                    <Select
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.zip_code}
                                        options={zipCodeSelectOptions}
                                        placeholder="เลือกรหัสไปรษณีย์"
                                        disabled={!formData.sub_district}
                                        onChange={(value) =>
                                          handleChange({ target: { name: "zip_code", value } })
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {activeTab === "work" && (
                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-2 mb-4">
                                <div>
                                    <div className="small text-uppercase fw-bold mb-2" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                        Work Information
                                    </div>
                                    <div style={{ color: "#2d6288", lineHeight: 1.7 }}>
                                        ข้อมูลตำแหน่งงาน โครงสร้างองค์กร และเงื่อนไขการจ้างงาน
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>แผนก {required}</label>
                                    <select name="department" className="form-select" style={modalInputStyle} value={formData.department} onChange={handleChange}>
                                        <option value="">เลือกแผนก</option>
                                        {departmentOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ตำแหน่ง {required}</label>
                                    <select name="position" className="form-select" style={modalInputStyle} value={formData.position} onChange={handleChange}>
                                        <option value="">เลือกตำแหน่ง</option>
                                        {positionOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>เงินเดือนพื้นฐาน</label>
                                    <input
                                        type="text"
                                        name="salary"
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formatSalaryDisplay(formData.salary)}
                                        onChange={handleChange}
                                        placeholder="0"
                                        inputMode="numeric"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ภาษีหัก ณ ที่จ่าย (%)</label>
                                    <div className="input-group" style={groupWrapStyle}>
                                        <input
                                            type="number"
                                            name="wht_rate"
                                            className="form-control"
                                            style={groupFieldStyle}
                                            value={formData.wht_rate}
                                            onChange={handleChange}
                                            placeholder="0"
                                            min="0"
                                            max="100"
                                            step="0.01"
                                        />
                                        <span className="input-group-text" style={groupAddonStyle}>%</span>
                                    </div>
                                    <div className="small mt-1" style={{ color: "#6b8198" }}>อัตรา % สำหรับคำนวณภาษีหัก ณ ที่จ่ายตอนออกเงินเดือน</div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>วันที่เริ่มงาน</label>
                                    <DateInput name="start_date" className="form-control" style={modalInputStyle} value={formData.start_date} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ช่วงเวลาเริ่มงาน</label>
                                    <input type="time" name="working_start_time" className="form-control" style={modalInputStyle} value={formData.working_start_time} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ช่วงเวลาเลิกงาน</label>
                                    <input type="time" name="working_end_time" className="form-control" style={modalInputStyle} value={formData.working_end_time} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>สถานะพนักงาน {required}</label>
                                    <select name="status" className="form-select" style={modalInputStyle} value={formData.status} onChange={handleChange}>
                                        <option value="">เลือกสถานะพนักงาน</option>
                                        {statusOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>สิทธิ์การใช้งาน {required}</label>
                                    <select name="role_id" className="form-select" style={modalInputStyle} value={formData.role_id} onChange={handleChange}>
                                        <option value="">เลือกสิทธิ์การใช้งาน</option>
                                        {roleOptions.map((role) => (
                                            <option key={role.uid} value={role.uid}>{role.name.replace(/_/g, " ").toUpperCase()}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {activeTab === "sso" && (
                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-2 mb-4">
                                <div>
                                    <div className="small text-uppercase fw-bold mb-2" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                        Social Security
                                    </div>
                                    <div style={{ color: "#2d6288", lineHeight: 1.7 }}>
                                        ข้อมูลผู้ประกันตนและอัตราเงินสมทบประกันสังคมสำหรับการคำนวณเงินเดือน
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-12">
                                    <div
                                        className="rounded-4 p-3 d-flex align-items-center justify-content-between"
                                        style={{ background: "rgba(255,255,255,0.92)", boxShadow: "inset 0 0 0 1px rgba(18, 125, 255, 0.16)" }}
                                    >
                                        <div>
                                            <div className="fw-semibold" style={{ color: "#12314d" }}>เข้าร่วมประกันสังคม</div>
                                            <div className="small" style={{ color: "#6b8198" }}>
                                                {formData.is_social_security ? "หักเงินสมทบประกันสังคมเมื่อออกเงินเดือน" : "ไม่หักเงินสมทบประกันสังคม"}
                                            </div>
                                        </div>
                                        <Switch
                                            checked={!!formData.is_social_security}
                                            onChange={(checked) => setFormData((current) => ({ ...current, is_social_security: checked }))}
                                            onColor="#0c75e6"
                                            offColor="#b7cadb"
                                            height={26}
                                            width={52}
                                            id="isSocialSecurity"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>เลขที่ประกันสังคม</label>
                                    <input
                                        type="text"
                                        name="sso_number"
                                        maxLength={13}
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.sso_number}
                                        onChange={handleChange}
                                        placeholder="เลขบัตรประชาชน / เลขผู้ประกันตน"
                                        disabled={!formData.is_social_security}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>มาตรา</label>
                                    <select
                                        name="sso_section"
                                        className="form-select"
                                        style={modalInputStyle}
                                        value={formData.sso_section}
                                        onChange={handleChange}
                                        disabled={!formData.is_social_security}
                                    >
                                        <option value="33">มาตรา 33</option>
                                        <option value="39">มาตรา 39</option>
                                        <option value="40">มาตรา 40</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>อัตราเงินสมทบ (%)</label>
                                    <div className="input-group" style={groupWrapStyle}>
                                        <input
                                            type="number"
                                            name="sso_rate"
                                            className="form-control"
                                            style={groupFieldStyle}
                                            value={formData.sso_rate}
                                            onChange={handleChange}
                                            placeholder="5"
                                            min="0"
                                            max="100"
                                            step="0.01"
                                            disabled={!formData.is_social_security}
                                        />
                                        <span className="input-group-text" style={groupAddonStyle}>%</span>
                                    </div>
                                    <div className="small mt-1" style={{ color: "#6b8198" }}>มาตรฐาน 5% ของค่าจ้าง</div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ฐานค่าจ้างสูงสุดที่คำนวณ (บาท)</label>
                                    <input
                                        type="number"
                                        name="sso_wage_ceiling"
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.sso_wage_ceiling}
                                        onChange={handleChange}
                                        placeholder="17500"
                                        min="0"
                                        step="1"
                                        disabled={!formData.is_social_security}
                                    />
                                    <div className="small mt-1" style={{ color: "#6b8198" }}>เพดานคำนวณตามกฎหมาย 17,500 บาท (สมทบสูงสุด 875 บาท)</div>
                                </div>
                                <div className="col-12">
                                    <label className="form-label" style={modalLabelStyle}>โรงพยาบาลตามสิทธิ์</label>
                                    <input
                                        type="text"
                                        name="sso_hospital"
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.sso_hospital}
                                        onChange={handleChange}
                                        placeholder="ระบุโรงพยาบาลตามสิทธิ์ประกันสังคม"
                                        disabled={!formData.is_social_security}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {activeTab === "bank" && (
                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="d-flex flex-column flex-md-row align-items-md-end justify-content-between gap-2 mb-4">
                                <div>
                                    <div className="small text-uppercase fw-bold mb-2" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                        Banking Information
                                    </div>
                                    <div style={{ color: "#2d6288", lineHeight: 1.7 }}>
                                        ข้อมูลบัญชีสำหรับการจ่ายเงินเดือนและรายการทางการเงินอื่น ๆ
                                    </div>
                                </div>
                            </div>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>ธนาคาร</label>
                                    <Select
                                        className="form-control"
                                        style={modalInputStyle}
                                        value={formData.bank_name}
                                        options={bankOptions}
                                        placeholder="เลือกธนาคาร"
                                        onChange={(value) =>
                                          handleChange({ target: { name: "bank_name", value } })
                                        }
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>เลขบัญชี</label>
                                    <input type="text" maxLength={10} name="bank_account_no" className="form-control" style={modalInputStyle} value={formData.bank_account_no} onChange={handleChange} placeholder="ระบุเลขบัญชี" />
                                </div>
                                <div className="col-12">
                                    <label className="form-label" style={modalLabelStyle}>ชื่อบัญชี</label>
                                    <input type="text" name="bank_account_name" className="form-control" style={modalInputStyle} value={formData.bank_account_name} onChange={handleChange} placeholder="ระบุชื่อบัญชีธนาคาร" />
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {activeTab === "employment" && editData?.uid && (
                    <>
                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="small text-uppercase fw-bold mb-3" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                Employment Contract
                            </div>
                            <div className="row g-4">
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>รูปแบบการจ้าง</label>
                                    <select name="employment_type" className="form-select" style={modalInputStyle} value={formData.employment_type} onChange={handleChange}>
                                        {employmentTypeOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>วันสิ้นสุดทดลองงาน</label>
                                    <DateInput name="probation_end_date" className="form-control" style={modalInputStyle} value={formData.probation_end_date} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>สัญญาเริ่มวันที่</label>
                                    <DateInput name="contract_start_date" className="form-control" style={modalInputStyle} value={formData.contract_start_date} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>สัญญาสิ้นสุดวันที่</label>
                                    <DateInput name="contract_end_date" className="form-control" style={modalInputStyle} value={formData.contract_end_date} onChange={handleChange} />
                                    <div className="small mt-1" style={{ color: "#6b8198" }}>เว้นว่างไว้ถ้าเป็นสัญญาไม่มีกำหนดสิ้นสุด</div>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>วันพ้นสภาพพนักงาน</label>
                                    <DateInput name="end_date" className="form-control" style={modalInputStyle} value={formData.end_date} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label" style={modalLabelStyle}>เหตุผลการพ้นสภาพ</label>
                                    <input type="text" name="resignation_reason" className="form-control" style={modalInputStyle} value={formData.resignation_reason} onChange={handleChange} placeholder="เช่น ลาออก, ครบสัญญา, เลิกจ้าง" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="p-4 p-md-4" style={sectionCardStyle}>
                            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2 mb-3">
                                <div className="small text-uppercase fw-bold" style={{ color: "#0c74bc", letterSpacing: "0.12em" }}>
                                    Employment History
                                </div>
                                <button type="button" className="btn btn-sm btn-outline-primary rounded-3" onClick={onAddHistory}>
                                    + บันทึกประวัติ
                                </button>
                            </div>
                            <div className="small mb-3" style={{ color: "#6b8198" }}>
                                ระบบบันทึกให้อัตโนมัติเมื่อมีการเปลี่ยนตำแหน่ง เงินเดือน แผนก รูปแบบการจ้าง สถานะ หรือวันพ้นสภาพ
                            </div>

                            <div className="table-responsive table-mobile-cards">
                                <table className="table table-sm align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="text-secondary fw-medium text-nowrap">มีผลวันที่</th>
                                            <th className="text-secondary fw-medium text-nowrap">ประเภท</th>
                                            <th className="text-secondary fw-medium">จากเดิม</th>
                                            <th className="text-secondary fw-medium">เป็น</th>
                                            <th className="text-secondary fw-medium">หมายเหตุ</th>
                                            <th className="text-secondary fw-medium text-center">จัดการ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {histories.length > 0 ? (
                                            histories.map((item) => (
                                                <tr key={item.uid}>
                                                    <td data-label="มีผลวันที่" className="text-nowrap">{format_date(item.effective_date, "dd/mm/yyyy")}</td>
                                                    <td data-label="ประเภท" className="text-nowrap">
                                                        <span className="rounded-pill px-3 py-1 small fw-semibold text-nowrap d-inline-block" style={{ background: "rgba(12, 117, 230, 0.10)", color: "#0b4f84" }}>
                                                            {historyTypeLabel(item.change_type)}
                                                        </span>
                                                    </td>
                                                    <td data-label="จากเดิม">{item.old_value || "-"}</td>
                                                    <td data-label="เป็น" className="fw-semibold">{item.new_value || "-"}</td>
                                                    <td data-label="หมายเหตุ" className="small text-secondary">{item.note || "-"}</td>
                                                    <td data-label="จัดการ" className="text-center">
                                                        <button type="button" className="btn btn-sm btn-outline-danger rounded-3" title="ลบ" onClick={() => onDeleteHistory(item)}>
                                                            <i className="fa-solid fa-trash" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center text-secondary py-4">ยังไม่มีประวัติการเปลี่ยนแปลง</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    </>
                    )}

                    {activeTab === "documents" && editData?.uid && (
                    <div className="col-12">
                        <DocumentManagerPanel ownerType="employee" ownerUid={editData.uid} />
                    </div>
                    )}
                </form>
            </Modal.Body>

            <Modal.Footer
                className="border-0 px-4 px-md-5 py-4"
                style={{
                    background: "linear-gradient(180deg, rgba(243,249,255,0.84) 0%, rgba(248,252,255,0.98) 100%)",
                }}
            >
                <div className="d-flex flex-column flex-sm-row gap-3 w-100 justify-content-end">
                    <button
                        type="button"
                        className="btn px-4"
                        onClick={onHide}
                        style={{
                            borderRadius: 16,
                            background: "#ffffff",
                            border: "1px solid rgba(18, 125, 255, 0.12)",
                            color: "#4f6d83",
                            fontWeight: 600,
                        }}
                    >
                        ยกเลิก
                    </button>
                    <button
                        type="button"
                        className="btn px-4 text-white"
                        onClick={() => onSave(formData)}
                        style={{
                            borderRadius: 16,
                            border: "none",
                            background: "linear-gradient(135deg, #0c75e6 0%, #2fd5e4 100%)",
                            boxShadow: "0 16px 28px rgba(12, 117, 230, 0.24)",
                            fontWeight: 700,
                        }}
                    >
                        บันทึกข้อมูล
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
  };

  export default function Employees() {
    const { title, description } = appModules["employees"];
    const [activeView, setActiveView] = useState("list");
    const [showModal, setShowModal] = useState(false);
    const [editData, setEditData] = useState(null);
    const [data, setData] = useState([]);
    const [roleOptions, setRoleOptions] = useState([]);
    const [histories, setHistories] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [departmentInput, setDepartmentInput] = useState("");
    const [statusInput, setStatusInput] = useState("");
    const [filters, setFilters] = useState({
      searchText: "",
      department: "",
      status: "",
    });

    const handleOpenModal = (data = null) => {
      setEditData(data);
      setShowModal(true);
      setHistories([]);
      if (data?.uid) getHistories(data.uid);
    };

    const handleCloseModal = () => {
      setEditData(null);
      setShowModal(false);
      setHistories([]);
    };

    // ประวัติการเปลี่ยนแปลงของพนักงานที่กำลังเปิดดูอยู่
    const getHistories = async (uid) => {
      const result = await GET(`v1/admin/employees/${uid}/histories`);
      if (result?.status) setHistories(result.data || []);
    };

    const handleAddHistory = async () => {
      if (!editData?.uid) return;

      const changeType = window.prompt(
        "ประเภทประวัติ (position/salary/department/employment_type/status/contract/resignation/training/award/warning/other)",
        "training"
      );
      if (changeType === null) return;

      const effectiveDate = window.prompt("มีผลวันที่ (YYYY-MM-DD)", new Date().toISOString().slice(0, 10));
      if (effectiveDate === null) return;

      const note = window.prompt("รายละเอียด / หมายเหตุ", "");
      if (note === null) return;

      loading(true);
      const result = await POST(`v1/admin/employees/${editData.uid}/histories`, {
        change_type: changeType.trim(),
        effective_date: effectiveDate.trim(),
        note: note.trim() || undefined,
      });
      loading(false);

      if (result?.status) {
        alert("", "success", "สำเร็จ", "บันทึกประวัติเรียบร้อย");
        getHistories(editData.uid);
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "บันทึกไม่สำเร็จ");
      }
    };

    const handleDeleteHistory = async (item) => {
      if (!editData?.uid) return;
      if (!(await alert("", "warning", "ลบประวัติ", "ต้องการลบรายการนี้?", "ลบ", "ยกเลิก"))) return;

      loading(true);
      const result = await DELETE(`v1/admin/employees/${editData.uid}/histories/${item.uid}`);
      loading(false);

      if (result?.status) {
        alert("", "success", "สำเร็จ", "ลบเรียบร้อย");
        getHistories(editData.uid);
      } else {
        alert("", "warning", "แจ้งเตือน", result?.message || "ลบไม่สำเร็จ");
      }
    };

    const GetData = async () => {
      loading(true);
      const body = {
        data_search: filters.searchText.trim() || "",
        department: filters.department || "",
        status: filters.status || "",
        page: 1,
        page_size: 100,
      };

      let result = await GET("v1/admin/employees", body);
      if (result?.status) {
        setData(result.data || []);
      }
      loading(false);
    };

    const GetRoles = async () => {
      const result = await GET("v1/admin/roles", {
        page: 1,
        page_size: 100,
      });

      if (result?.status) {
        setRoleOptions(result.data || []);
      }
    };

    useEffect(() => {
      GetRoles();
    }, []);

    useEffect(() => {
      GetData();
    }, [filters]);

    const handleSearch = () => {
      setFilters({
        searchText: searchInput,
        department: departmentInput,
        status: statusInput,
      });
    };

    const handleResetFilters = () => {
      setSearchInput("");
      setDepartmentInput("");
      setStatusInput("");
      setFilters({
        searchText: "",
        department: "",
        status: "",
      });
    };

    const CreateUpdate = async (formData) => {
      const requiredFields = [
        { key: "prefix_name", label: "คำนำหน้า" },
        { key: "first_name", label: "ชื่อ" },
        { key: "last_name", label: "นามสกุล" },
        { key: "department", label: "แผนก" },
        { key: "position", label: "ตำแหน่ง" },
        { key: "status", label: "สถานะพนักงาน" },
        { key: "role_id", label: "สิทธิ์การใช้งาน" },
      ];

      if (!editData) {
        requiredFields.push({ key: "password", label: "Password" });
      }

      const missingField = requiredFields.find(({ key }) => {
        const value = formData?.[key];
        return value === undefined || value === null || String(value).trim() === "";
      });

      if (missingField) {
        await alert("", "warning", "แจ้งเตือน", `กรุณากรอกข้อมูล ${missingField.label}`);
        return;
      }

      if (
        await alert("", "info", "ยืนยัน", "ยืนยันการบันทึกข้อมูลหรือไม่?", "ยืนยัน", "ยกเลิก")
      ) {
        loading(true);
        let uid = formData?.uid || editData?.uid;
        let body = { ...formData };
        delete body.employee_code;
        // ฟิลด์ลายเซ็นที่ใช้แสดงผลอย่างเดียว ไม่ต้องส่งขึ้น API
        delete body.signature_url;
        delete body.signature_name;
        delete body.signature_mime;
        delete body.signature_type;
        if (!body.signature_file) delete body.signature_file;
        if (!body.signature_remove) delete body.signature_remove;
        if (uid) {
          // อัปเดต: ไม่ส่ง password (DTO ฝั่ง update ไม่รับ)
          delete body.password;
        } else {
          // สร้างใหม่: ไม่ส่ง uid ว่าง (DTO ฝั่ง create ไม่รับ)
          delete body.uid;
        }

        let result = !uid
          ? await POST("v1/admin/employees", body)
          : await PUT("v1/admin/employees/" + uid, body);
          
        if (result?.status === true) {
          alert("", "success", "สำเร็จ", "ทำรายการสำเร็จแล้ว");
          GetData();
          handleCloseModal();
        } else {
          alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        }
        loading(false);
      }
    };

    return (
        <AppShell title={title} description={description}>
            <style>{`
                .ptn-view-switch {
                    display: inline-flex;
                    gap: 4px;
                    padding: 4px;
                    border-radius: 16px;
                    background: #ffffff;
                    border: 1px solid rgba(18, 125, 255, 0.14);
                    box-shadow: 0 6px 16px rgba(12, 118, 229, 0.08);
                }
                .ptn-view-switch__btn {
                    display: inline-flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.55rem 1.1rem;
                    border: 0;
                    border-radius: 12px;
                    background: transparent;
                    color: #4f6d83;
                    font-weight: 700;
                    font-size: 0.88rem;
                    transition: background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
                }
                .ptn-view-switch__btn:hover { background: rgba(12, 118, 229, 0.06); color: #0b4f84; }
                .ptn-view-switch__btn.is-active {
                    background: linear-gradient(135deg, #0b4f84 0%, #0c76e5 100%);
                    color: #ffffff;
                    box-shadow: 0 8px 18px rgba(12, 118, 229, 0.30);
                }
                @media (max-width: 575px) {
                    .ptn-view-switch { width: 100%; }
                    .ptn-view-switch__btn { flex: 1; justify-content: center; }
                }
            `}</style>
            <div className="mb-3">
                <div className="ptn-view-switch" role="tablist" aria-label="มุมมองหน้าพนักงาน">
                    {pageViews.map((view) => (
                        <button
                            key={view.key}
                            type="button"
                            role="tab"
                            aria-selected={activeView === view.key}
                            className={`ptn-view-switch__btn${activeView === view.key ? " is-active" : ""}`}
                            onClick={() => setActiveView(view.key)}
                        >
                            <i className={view.icon} />
                            {view.label}
                        </button>
                    ))}
                </div>
            </div>

            {activeView === "org" && <OrgChartMatrix />}

            {activeView === "list" && (
            <>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
                <div className="d-flex gap-2 flex-wrap filters-mobile-stack">
                    <input
                        type="text"
                        className="form-control"
                        value={searchInput}
                        onChange={(event) => setSearchInput(event.target.value)}
                        placeholder="ค้นหาพนักงาน..."
                        style={{ width: "250px", borderRadius: "12px" }}
                    />
                    <select className="form-select" value={departmentInput} onChange={(event) => setDepartmentInput(event.target.value)} style={{ width: "180px", borderRadius: "12px" }}>
                        <option value="">ทุกแผนก</option>
                        {departmentOptions.map((dept) => (
                            <option key={dept.value} value={dept.value}>
                                {dept.label}
                            </option>
                        ))}
                    </select>
                    <select className="form-select" value={statusInput} onChange={(event) => setStatusInput(event.target.value)} style={{ width: "180px", borderRadius: "12px" }}>
                        <option value="">ทุกสถานะ</option>
                        {statusOptions.map((status) => (
                            <option key={status.value} value={status.value}>
                                {status.label}
                            </option>
                        ))}
                    </select>
                    <button type="button" className="btn btn-primary px-4" onClick={handleSearch} style={{ borderRadius: "12px" }}>
                        ค้นหา
                    </button>
                    <button
                        type="button"
                        className="btn btn-light px-4"
                        onClick={handleResetFilters}
                        style={{
                            borderRadius: "12px",
                            border: "1px solid rgba(18, 125, 255, 0.14)",
                            color: "#4f6d83",
                        }}
                    >
                        ล้างค่า
                    </button>
                </div>
                <button onClick={() => handleOpenModal()} className="btn btn-primary px-4">
                    + เพิ่มพนักงาน
                </button>
            </div>

            <div
                className="rounded-4 p-3 bg-white"
                style={{
                    border: "1px solid rgba(18, 125, 255, 0.10)",
                    boxShadow: "0 4px 12px rgba(12, 118, 229, 0.04)",
                }}
            >
                <style>{`
                    @keyframes birthdayPulse {
                        0%, 100% { transform: scale(1); box-shadow: 0 8px 18px rgba(255, 94, 138, 0.45); }
                        50% { transform: scale(1.05); box-shadow: 0 10px 24px rgba(255, 94, 138, 0.65); }
                    }
                    .birthday-pulse { animation: birthdayPulse 1.6s ease-in-out infinite; }
                    @keyframes partyHatWiggle {
                        0%, 100% { transform: rotate(-5deg); }
                        50% { transform: rotate(5deg); }
                    }
                    .party-hat { animation: partyHatWiggle 2.2s ease-in-out infinite; transform-origin: bottom center; }

                    /* ===== มุมมองการ์ดบนมือถือ ===== */
                    @media (max-width: 767px) {
                        .employees-cards tbody tr {
                            padding: 0 !important;
                            overflow: hidden;
                            border-radius: 18px !important;
                            border: 1px solid rgba(18, 125, 255, 0.12) !important;
                            box-shadow: 0 12px 26px rgba(12, 118, 229, 0.08) !important;
                            background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%) !important;
                        }
                        .employees-cards td {
                            padding: 0.6rem 0.95rem !important;
                            font-size: 0.9rem;
                            border-bottom: 1px dashed rgba(18, 125, 255, 0.12) !important;
                        }
                        .employees-cards td::before {
                            font-size: 0.72rem;
                            font-weight: 700;
                            letter-spacing: 0.05em;
                            text-transform: uppercase;
                            color: #8299ab;
                        }
                        /* แถบหัวการ์ด = รหัสพนักงาน */
                        .employees-cards td[data-label="รหัส"] {
                            background: linear-gradient(135deg, #0b4f84 0%, #0c76e5 100%);
                            color: #ffffff;
                            font-weight: 700;
                            letter-spacing: 0.04em;
                            border-bottom: none !important;
                            padding: 0.7rem 0.95rem !important;
                        }
                        .employees-cards td[data-label="รหัส"]::before { color: rgba(255, 255, 255, 0.72); }
                        /* ชื่อ-นามสกุล = บล็อกเด่นเต็มความกว้าง */
                        .employees-cards td[data-label="ชื่อ-นามสกุล"] {
                            display: block;
                            text-align: left !important;
                            padding-top: 0.85rem !important;
                            padding-bottom: 0.8rem !important;
                        }
                        .employees-cards td[data-label="ชื่อ-นามสกุล"]::before { display: none; }
                        .employees-cards td[data-label="ชื่อ-นามสกุล"] > div {
                            align-items: flex-start;
                            text-align: left;
                        }
                        .employees-cards td[data-label="ชื่อ-นามสกุล"] .fw-medium {
                            font-size: 1.05rem;
                            font-weight: 700 !important;
                            color: #0b4f84;
                            line-height: 1.3;
                        }
                        /* แถวข้อมูลย่อย: ค่าอยู่ขวา อ่านคู่กับป้ายซ้ายได้ทันที */
                        .employees-cards td[data-label="ชื่อเล่น"] { color: #22384a; font-weight: 600; }
                        .employees-cards td[data-label="ตำแหน่ง"] { padding-top: 0.7rem !important; }
                        /* ปุ่มจัดการ = แถบท้ายการ์ดเต็มความกว้าง */
                        .employees-cards td[data-label="จัดการ"] {
                            display: block;
                            background: rgba(12, 118, 229, 0.05);
                            border-bottom: none !important;
                            padding: 0.75rem 0.95rem !important;
                        }
                        .employees-cards td[data-label="จัดการ"]::before { display: none; }
                        .employees-cards td[data-label="จัดการ"] .btn {
                            width: 100%;
                            border-radius: 12px;
                            font-weight: 600;
                            padding-top: 0.5rem;
                            padding-bottom: 0.5rem;
                        }
                    }
                `}</style>
                <div className="table-responsive table-mobile-cards employees-cards">
                    <table className="table table-hover align-middle">
                        <thead className="table-light">
                            <tr>
                                <th className="text-secondary fw-medium rounded-start">รหัส</th>
                                <th className="text-secondary fw-medium">ชื่อ-นามสกุล</th>
                                <th className="text-secondary fw-medium">ชื่อเล่น</th>
                                <th className="text-secondary fw-medium">ตำแหน่ง</th>
                                <th className="text-secondary fw-medium">เริ่มทำงาน</th>
                                <th className="text-secondary fw-medium">เวลาทำงาน</th>
                                <th className="text-secondary fw-medium">วันเกิด</th>
                                <th className="text-secondary fw-medium">สถานะ</th>
                                <th className="text-secondary fw-medium rounded-end">จัดการ</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((employee) => {
                                    const birthdayThisMonth = isBirthdayThisMonth(employee.birthday);
                                    return (
                                    <tr
                                        key={employee.uid}
                                        style={
                                            birthdayThisMonth
                                                ? { background: "linear-gradient(90deg, rgba(255, 94, 138, 0.08) 0%, rgba(255, 209, 102, 0.10) 100%)" }
                                                : undefined
                                        }
                                    >
                                        <td data-label="รหัส">{employee.employee_code || "-"}</td>
                                        <td data-label="ชื่อ-นามสกุล">
                                            <div>
                                                <div className="fw-medium">{getFullName(employee)}</div>
                                                <div className="small text-secondary">{employee.email || "-"}</div>
                                            </div>
                                        </td>
                                        <td data-label="ชื่อเล่น">
                                            {(() => {
                                                const nickname = employee.nickname || "-";
                                                if (!birthdayThisMonth) {
                                                    return <span className="fw-medium">{nickname}</span>;
                                                }
                                                const headChars = nickname.slice(0, -1);
                                                const lastChar = nickname.slice(-1);
                                                return (
                                                    <span
                                                        className="d-inline-flex align-items-baseline fw-medium"
                                                        style={{ color: "#d24a6e" }}
                                                    >
                                                        <span>{headChars}</span>
                                                        {/* หมวกปาร์ตี้อยู่บนตัวอักษรท้ายของชื่อเล่น */}
                                                        <span style={{ position: "relative", display: "inline-block" }}>
                                                            <span className="fw-bold">{lastChar}</span>
                                                            <PartyHat />
                                                        </span>
                                                    </span>
                                                );
                                            })()}
                                        </td>
                                        <td data-label="ตำแหน่ง"><PositionBadge position={employee.position} /></td>
                                        <td data-label="เริ่มทำงาน">{employee.start_date ? format_date(employee.start_date, "dd/mm/yyyy") : "-"}</td>
                                        <td data-label="เวลาทำงาน" className="text-nowrap">{formatWorkingHours(employee)}</td>
                                        <td data-label="วันเกิด">{renderBirthdayCountdown(employee.birthday)}</td>
                                        <td data-label="สถานะ">
                                            <span className="rounded-pill px-3 py-2 d-inline-flex small fw-semibold" style={getStatusBadgeStyle(employee.status)}>
                                                {employee.status || "-"}
                                            </span>
                                        </td>
                                        <td data-label="จัดการ">
                                            <button onClick={() => handleOpenModal(employee)} className="btn btn-sm btn-outline-secondary rounded-3" title="แก้ไข">
                                                <i className="fa-solid fa-pen" />
                                                <span className="d-inline d-md-none ms-2">แก้ไขข้อมูล</span>
                                            </button>
                                        </td>
                                    </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-5 text-secondary">
                                        ไม่พบข้อมูลพนักงาน
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            </>
            )}

            <EmployeeModal
              show={showModal}
              onHide={handleCloseModal}
              editData={editData}
              onSave={CreateUpdate}
              roleOptions={roleOptions}
              histories={histories}
              onAddHistory={handleAddHistory}
              onDeleteHistory={handleDeleteHistory}
            />
        </AppShell>
    );
  }
